module.exports = __webpack_public_path__ + "img/style_swiper_05_active.c63af204.png";